import { isNil } from 'ramda'

export const getInitialData = (key) => {
  // eslint-disable-next-line
  const data = JSON.parse(window.__initialData__)
  if (data && data[key]) return data[key]
  return null
}

export const filterInvalidImages = images =>
  images.filter(img => !isNil(img))



// WEBPACK FOOTER //
// ./src/helpers.js